module.exports = __webpack_public_path__ + "static/media/m-penguin-ground.79cb2689.png";